/**
    Parse images URL in order to display them corectly.
    If the value is null the function returns a default image.
 */

const FilterImageUrlParse = (value) => {

    if (value) {

        return JSON.parse(`"${value}"`);

    }
    return 'https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png';

};

export default FilterImageUrlParse;



// WEBPACK FOOTER //
// ./scripts/common/filters/-RFC.imageUrlParse.js